import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import InitialDataLoadedGate from 'components/InitialDataLoadedGate';
// @ts-ignore
import UsersMeRequest from 'components/UsersMeRequest';
// @ts-ignore
import InitialDataLoadedErrorGate from 'components/InitialDataLoadedErrorGate';
// @ts-ignore
import SplashScreen from 'components/SplashScreen';
import Organization from 'scenes/Organization';
// @ts-ignore
import Organizations from 'scenes/Organizations';

// @ts-ignore
import RenewIdToken from './components/RenewIdToken';
import FeedbackModal from './components/FeedbackModal';
import SupportModal from './components/SupportModal';

const { REACT_APP_PROJECT_NAME } = process.env;

const Home = (): React.ReactElement => (
    <ErrorBoundary namespace="Home" FallbackComponent={<ErrorBoundaryAlert />}>
        <Helmet>
            <title>Home - {REACT_APP_PROJECT_NAME}</title>
        </Helmet>
        <RenewIdToken />
        <Online>
            <UsersMeRequest />
        </Online>
        <InitialDataLoadedErrorGate
            namespace="USERS_ME_LOAD"
            displayLogoutButton
        >
            <InitialDataLoadedGate
                namespace="USERS_ME_LOAD"
                LoadingComponent={<SplashScreen />}
            >
                <Switch>
                    <Redirect exact from="/" to="/organization" />
                    <Route path="/organizations" component={Organizations} />
                    <Route path="/organization" component={Organization} />
                    <Redirect from="/*" to="/organizations" />
                </Switch>
            </InitialDataLoadedGate>
        </InitialDataLoadedErrorGate>
        <FeedbackModal />
        <SupportModal />
    </ErrorBoundary>
);

export default Home;
